export default __webpack_public_path__ + "static/CopernicusWeb-BookItalic-9694554f11a4ca910b0826ef906f7f7d.woff";